/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /*
   * Cart drawer recommended products slider ("recobox")
   * ------------------------------------------------------------
   * <reco-slider> wraps the recommended product cards rendered by
   * snippet 'cart-recommendation'. It initializes a pagination-only
   * Flickity carousel (no arrows) when more than one card qualifies,
   * mirroring the theme's existing "Buy it with" pair-products slider.
   * Because it is a custom element, it re-initializes automatically
   * whenever the recobox markup replaces `[data-reco-holder]` innerHTML
   * below — no manual re-render hook needed.
   */
  if (!customElements.get('reco-slider')) {
    customElements.define('reco-slider', class extends HTMLElement {
      connectedCallback() {
        this.flkty = null;

        var cards = this.querySelectorAll('[data-reco-card]');
        if (cards.length < 2 || !window.theme || !window.theme.Flickity) return;

        this.flkty = new window.theme.Flickity(this, {
          wrapAround: true,
          pageDots: true,
          adaptiveHeight: false,
          prevNextButtons: false,
        });
      }

      disconnectedCallback() {
        if (this.flkty) {
          this.flkty.destroy();
          this.flkty = null;
        }
      }
    });
  }

  /*
   * Cart drawer recommended product ("recobox")
   * ------------------------------------------------------------
   * Keeps the recommended product block in the cart drawer in sync with the
   * cart. The block itself is rendered server-side (snippet 'cart-recommendation')
   * and refreshed via the Section Rendering API (section 'api-cart-reco') so it
   * disappears once the product is in the cart and reappears when it is removed.
   * Add-to-cart works through the theme's native 'quick-add-button' handler, so
   * no cart logic is duplicated here.
   */
  (function cartRecommendation() {
    var SECTION_ID = 'api-cart-reco';
    var HOLDER_SELECTOR = '[data-reco-holder]';
    var ITEMS_SELECTOR = '[data-items-holder]';

    var isFetching = false;
    var refreshQueued = false;
    var observedItemsHolder = null;

    function getCartUrl() {
      return (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
    }

    function getHolder() {
      var drawer = document.querySelector('#cart-drawer');
      if (!drawer) return null;
      return drawer.querySelector(HOLDER_SELECTOR);
    }

    function refreshReco() {
      var holder = getHolder();
      if (!holder) return;

      if (isFetching) {
        refreshQueued = true;
        return;
      }
      isFetching = true;

      fetch(getCartUrl() + '?section_id=' + SECTION_ID)
        .then(function(response) {
          return response.ok ? response.text() : Promise.reject(response.status);
        })
        .then(function(html) {
          var parsed = document.createElement('div');
          parsed.innerHTML = html;

          var fresh = parsed.querySelector('[data-api-reco-content]');
          var currentHolder = getHolder();
          if (currentHolder) {
            currentHolder.innerHTML = fresh ? fresh.innerHTML : '';
          }
        })
        .catch(function() {
          /* fail silently — recobox is non-critical */
        })
        .finally(function() {
          isFetching = false;
          if (refreshQueued) {
            refreshQueued = false;
            refreshReco();
          }
        });
    }

    // Coalesce bursts of cart mutations into a single refresh.
    var scheduled = false;
    function scheduleRefresh() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function() {
        scheduled = false;
        refreshReco();
      });
    }

    function observeItems() {
      var drawer = document.querySelector('#cart-drawer');
      if (!drawer) return;

      var itemsHolder = drawer.querySelector(ITEMS_SELECTOR);
      if (!itemsHolder || itemsHolder === observedItemsHolder) return;

      observedItemsHolder = itemsHolder;
      var observer = new MutationObserver(scheduleRefresh);
      observer.observe(itemsHolder, {childList: true});
    }

    // Drawer is lazy-rendered from a <template>; wire up once it is live.
    document.addEventListener('theme:cart:loaded', function() {
      observeItems();
      scheduleRefresh();
    });

    // Covers add-to-cart from anywhere on the page.
    document.addEventListener('theme:cart:added', scheduleRefresh);
  })();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
